import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Legacy .js file: explicit-module-boundary-types expects typed props and return on exports.

export const RuleStatusPill = ({ type }) => {
	const { t } = useTranslation();
	return (
		<div className="RuleStatusPill">
			{type === "blocked" && <div className="RuleStatusPill_item--blocked">{t("policyDrawer.ruleStatusBlocked")}</div>}
			{type === "allowed" && <div className="RuleStatusPill_item--allowed">{t("policyDrawer.ruleStatusAllowed")}</div>}
		</div>
	);
};

RuleStatusPill.propTypes = {
	type: PropTypes.oneOf(["blocked", "allowed"]).isRequired,
};
